import { Component, OnInit } from '@angular/core';
import { TableMeta } from 'projects/dop-table/src/lib/models/table-meta.model';
import { ColumnsMeta } from 'projects/dop-table/src/lib/models/columns-meta.model';
import { FilterRequest } from 'src/app/shared/models/filter-request.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ErrorGridDialogMessageService } from './error-grid-dialog.message.service';
import { ButtonType } from '../../models/constants/button-type.constant';

@Component({
  selector: 'app-error-grid-dialog',
  templateUrl: './error-grid-dialog.component.html',
  styleUrls: ['./error-grid-dialog.component.scss']
})
export class ErrorGridDialogComponent {

  tableMeta: TableMeta;
  errorGridColumnMeta: ColumnsMeta[] = [];
  finalGridData: any;
  gridData: any;
  totalRecords = 1;
  displayOkButton = false;
  columnHeader: string[] = [];
  errorMessage = '';

  constructor(
    private config: DynamicDialogConfig,
    private errorGridMsgService: ErrorGridDialogMessageService
  ) {

    this.tableMeta = {
      displayGlobalSearch: false,
      displayCheckBox: false,
      displayContextMenu: false,
      displayKebabMenu: false,
      displayEditMenu: false,
      displayDeleteMenu: false,
      showAccountSearch: false,
      displayCreateButton: false,
      displayUploadButton: false,
      displayDownloadButton: false
    };
    if (this.config.data) {
      this.displayOkButton = this.config.data.displayOkButton;
      this.gridData = this.config.data.gridData;
      this.columnHeader = this.config.data.columnHeader;
      this.errorMessage = this.config.data.errorMessage;
      this.setUpData();
    }
  }

  setUpData() {
    this.totalRecords = this.gridData.length;
    this.onHeaderChange();
  }

  onHeaderChange() {
    this.errorGridColumnMeta = [];
    for (const value of this.columnHeader) {
      this.errorGridColumnMeta.push({
        field: value,
        header: this.titleCase(value),
        sortable: false,
        selectable: false,
      });
    }
  }

  receiveFilterChange(event: FilterRequest) {
    const temp = (event.pageNumber - 1) * event.pageSize;
    this.finalGridData = this.gridData.slice(temp, temp + event.pageSize);
  }

  titleCase(text: string): string {
    return text.replace(/([A-Z])/g, (match) => ` ${match}`).replace(/^./, (match) => match.toUpperCase()).trim();
  }

  onCancelButtonClick() {
    this.errorGridMsgService.PublishMessage(ButtonType.Cancel);
  }

  onOkButtonClick() {
    this.errorGridMsgService.PublishMessage(ButtonType.Ok);
  }
}
